import React from "react";
import AnimatedPageContainer from "../../../assets/containers/AnimatedPageContainer";
import QuestsMenu from "./QuestsMenu";

export default function MatchQuests() {
  return (
    <div className="customContainer">
      <AnimatedPageContainer>
        <QuestsMenu />
      </AnimatedPageContainer>
    </div>
  );
}
